import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { fetchAddOrEditPostSubmission } from 'modules/posts/actions';
import AddPostComponent from 'modules/posts/components/AddPostComponent';
import { fileUploaderIsolatedFileTypeEnum } from 'modules/common/enums';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const AddPostContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const { postDetails } = useSelector(state => ({
    postDetails: state.posts.postDetails,
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id: postKey } = useParams();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [formFieldsValues, setFormFieldsValues] = useState({
    text: (postKey && postDetails.text) || '',
    topic: (postKey && postDetails.topics) || [],
    media: {
      totalCompressedFilesSize: 0,
      uploadedFiles: [],
    },
  });
  const [formFieldsValidation, setFormFieldsValidation] = useState({
    content: true,
    topic: true,
  });
  const [uploadMediaErrorMessage, setUploadMediaErrorMessage] = useState('');
  const [shouldShowErrorMessage, setShouldShowErrorMessage] = useState(false);
  const [isPreviewFilePopupOpen, setIsPreviewFilePopupOpen] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState('');
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  const addOrEditPostSuccessCallback = () => {
    navigate('/posts');
  };

  const addOrEditPostFailCallback = () => {
    setShouldShowErrorMessage(true);
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleTextInputFieldChange = (fieldName, fieldEvent) => {
    const { value } = fieldEvent.target;

    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = value;

      return fieldsObj;
    });
  };

  const handleMultiSelectionDropdownFieldChange = (fieldName, fieldValue) => {
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = fieldValue;

      return fieldsObj;
    });
  };

  const handleUploadFileChange = fileData => {
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj.media = fileData;

      return fieldsObj;
    });
  };

  const handleUploadFileErrorChange = errorMessage => {
    setUploadMediaErrorMessage(errorMessage);
  };

  const handlePreviewFileClick = (openPopup, fileData) => {
    if (fileData.fileTypeId === fileUploaderIsolatedFileTypeEnum.image) {
      if (openPopup) {
        setPreviewFileUrl(fileData.dataUrl);
        setIsPreviewFilePopupOpen(true);
      } else setIsPreviewFilePopupOpen(false);
    } else {
      window.open(fileData.windowUrl);
    }
    setUploadMediaErrorMessage('');
  };

  const handleDeleteFileIconClick = (event, index) => {
    if (event) event.stopPropagation();

    setFormFieldsValues(prevValue => {
      const fieldsObj = JSON.parse(JSON.stringify(prevValue));
      const uploadedFiles = [...fieldsObj.media.uploadedFiles];
      const [deletedFile] = uploadedFiles.splice(index, 1);
      fieldsObj.media.uploadedFiles = uploadedFiles;
      fieldsObj.media.totalCompressedFilesSize -= deletedFile.compressedFileData.size;

      return fieldsObj;
    });

    setUploadMediaErrorMessage('');
  };

  const handleAddOrEditPostBtnClick = () => {
    let isFormValid = true;

    if (
      (!formFieldsValues.text && !formFieldsValues.media.uploadedFiles.length) ||
      !formFieldsValues.topic.length
    ) {
      setFormFieldsValidation({
        content: !!(formFieldsValues.text || formFieldsValues.media.uploadedFiles.length),
        topic: !!formFieldsValues.topic.length,
      });
      isFormValid = false;
    }

    if (isFormValid === false) return;

    setFormFieldsValidation({
      content: true,
      topic: true,
    });

    const body = {
      data: {
        postText: formFieldsValues.text,
        postTopics: formFieldsValues.topic,
        postMedia: formFieldsValues.media.uploadedFiles,
        isMediaOfTypeImage:
          formFieldsValues.media.uploadedFiles[0]?.fileTypeId ===
          fileUploaderIsolatedFileTypeEnum.image,
      },
      callbackActionSuccess: addOrEditPostSuccessCallback,
      callbackActionFail: addOrEditPostFailCallback,
    };

    dispatch(fetchAddOrEditPostSubmission(body));
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <AddPostComponent
      formFieldsValues={formFieldsValues}
      formFieldsValidation={formFieldsValidation}
      uploadMediaErrorMessage={uploadMediaErrorMessage}
      shouldShowErrorMessage={shouldShowErrorMessage}
      isPreviewFilePopupOpen={isPreviewFilePopupOpen}
      previewFileUrl={previewFileUrl}
      handleTextInputFieldChange={handleTextInputFieldChange}
      handleMultiSelectionDropdownFieldChange={handleMultiSelectionDropdownFieldChange}
      handleUploadFileChange={handleUploadFileChange}
      handleUploadFileErrorChange={handleUploadFileErrorChange}
      handlePreviewFileClick={handlePreviewFileClick}
      handleDeleteFileIconClick={handleDeleteFileIconClick}
      handleAddOrEditPostBtnClick={handleAddOrEditPostBtnClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

AddPostContainer.propTypes = {};

AddPostContainer.defaultProps = {};

export default AddPostContainer;
